import apiRequestService from '@/commonProject/service/apiRequestService';

export default class NewsRepository {
    /**
     * お知らせ一覧取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getNewsListApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/nfylst', requestBody, idToken);
        return result;
    }
    /**
     * お知らせ詳細取得API
     * @param {requestForm} req
     * @returns result
     */
    async getNewsDetailApi(API_URL, queryParam, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/nfydtl', queryParam, idToken);
        return result;
    }
    /**
     * お知らせ既読API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async updateNewsReadedApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/nfyred', requestBody, idToken);
        return result;
    }
    /**
     * お知らせ回答API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async updateNewsApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/nfyres', requestBody, idToken);
        return result;
    }
}
